import { t } from "@travily/i18n";
import { Button as RACButton } from "@ui/primitives/Button";
import { type AccountType, AccountTypeCard } from "@/components/AccountTypeCard/AccountTypeCard";

const ACCOUNT_TYPES: AccountType[] = ["family", "community", "individual"];

export interface NewViewProps {
  onSelectType: (type: AccountType) => void;
  onSkip: () => void;
  /** Types the user can't create another of (already owns one). Family/individual are singular;
   *  community is never disabled. */
  disabledTypes?: AccountType[];
}

export function NewView({ onSelectType, onSkip, disabledTypes = [] }: NewViewProps) {
  return (
    <>
      <div className="min-h-0 grow" />

      <div className="flex flex-col items-center px-4 text-center sm:px-6 lg:px-0">
        <h1 className="text-display-sm text-green-950 sm:h-md:text-display-md md:h-lg:text-display-lg lg:h-xl:text-display-xl">
          {t("web.accounts.new.show.title")}
        </h1>
        <p className="text-secondary mt-1 text-base h-lg:mt-2 sm:h-md:text-lg md:h-lg:text-xl lg:h-xl:text-2xl">
          {t("web.accounts.new.show.subtitle")}
        </p>
      </div>

      <div className="min-h-6 max-h-12 grow lg:min-h-1 lg:max-h-3 lg:px-0" />

      <div className="flex w-full flex-col items-center gap-6 px-4 sm:px-6 lg:flex-row lg:items-stretch lg:justify-center lg:px-0">
        {/* i18n-tasks-use t('web.accounts.new.show.types.family.title') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.family.subtitle') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.family.button') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.family.button_short') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.community.title') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.community.subtitle') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.community.button') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.community.button_short') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.individual.title') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.individual.subtitle') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.individual.button') */}
        {/* i18n-tasks-use t('web.accounts.new.show.types.individual.button_short') */}
        {ACCOUNT_TYPES.map((type) => {
          const isDisabled = disabledTypes.includes(type);
          return (
            <AccountTypeCard
              key={type}
              type={type}
              title={t(`web.accounts.new.show.types.${type}.title`)}
              subtitle={t(`web.accounts.new.show.types.${type}.subtitle`)}
              buttonText={t(`web.accounts.new.show.types.${type}.button`)}
              buttonTextShort={t(`web.accounts.new.show.types.${type}.button_short`)}
              onPress={() => onSelectType(type)}
              isDisabled={isDisabled}
              // Mobile: stack disabled (already-owned) cards last; desktop keeps the natural order.
              className={isDisabled ? "order-last lg:order-none" : undefined}
            />
          );
        })}
      </div>

      <RACButton
        className="mt-10 cursor-pointer text-lg font-medium text-neutral-500 underline-offset-4 outline-none hover:underline focus-visible:underline"
        onPress={onSkip}
      >
        {t("web.accounts.new.show.skip")}
      </RACButton>

      <div className="min-h-0 grow" />
    </>
  );
}
